// Preparazione immagini lato client: foto iPhone (HEIC) e immagini grandi
// vengono convertite/ridotte prima dell'upload. Se non possibile, l'originale
// va al server che converte con pillow-heif. L'originale resta sempre immutabile.

function readAsDataURL(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
}

function loadImage(dataUrl) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = rej;
    img.src = dataUrl;
  });
}

export async function prepareImage(file) {
  const isImage = file.type.startsWith("image/") || /\.hei[cf]$/i.test(file.name);
  if (!isImage) {
    return { dataUrl: await readAsDataURL(file), filename: file.name, preprocessed: false };
  }
  const isHeic = /heic|heif/i.test(file.type) || /\.hei[cf]$/i.test(file.name);
  const isBig = file.size > 2_500_000;
  if (!isHeic && !isBig) {
    return { dataUrl: await readAsDataURL(file), filename: file.name, preprocessed: false };
  }
  try {
    const dataUrl = await readAsDataURL(file);
    const img = await loadImage(dataUrl);
    const scale = Math.min(1, 2000 / Math.max(img.width, img.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
    const out = canvas.toDataURL("image/jpeg", 0.85);
    return { dataUrl: out, filename: file.name.replace(/\.hei[cf]$/i, ".jpg"), preprocessed: true };
  } catch {
    // es. HEIC fuori Safari: il server converte con pillow-heif
    return { dataUrl: await readAsDataURL(file), filename: file.name, preprocessed: false };
  }
}
